import React, { PropsWithChildren, ReactNode } from "react";
import { AppBar, Toolbar, IconButton, Typography } from "@material-ui/core";
import { Menu as MenuIcon } from "@material-ui/icons";

import classNames from "classnames";

// styles
import useHeaderStyle from "./header.style";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../../context";

export interface HeaderProps extends PropsWithChildren<any> {
  title: string;
  icons?: ReactNode[];
  actions: ReactNode[] | ReactNode;
}

export function Header(props: HeaderProps) {
  const { title, actions, icons } = props;

  const classes = useHeaderStyle();

  const layoutState = useLayoutState();
  const layoutDispatch = useLayoutDispatch();
  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          color="inherit"
          onClick={() => toggleSidebar(layoutDispatch)}
          className={classNames(
            classes.headerMenuButtonSandwich,
            classes.headerMenuButtonCollapse
          )}
        >
          {layoutState.isSidebarOpened ? (
            <MenuIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse
                ),
              }}
            />
          ) : (
            <MenuIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse
                ),
              }}
            />
          )}
        </IconButton>
        <Typography className={classes.logotype}>{title}</Typography>
        <div className={classes.grow} />
        {actions}
        {icons}
      </Toolbar>
    </AppBar>
  );
}
